'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _entry = require('@routes/entry');

var _entry2 = _interopRequireDefault(_entry);

var _vip = require('@routes/vip');

var _vip2 = _interopRequireDefault(_vip);

var _user = require('@routes/user');

var _user2 = _interopRequireDefault(_user);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _store = require('@utils/store');

var _store2 = _interopRequireDefault(_store);

var _utils = require('@utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// import errors from '@routes/errors';

// import axios from 'axios';


// 配置路由
var routes = [].concat(_toConsumableArray(_entry2.default), _toConsumableArray(_vip2.default), _toConsumableArray(_user2.default));

// 初始化路由
var router = new _vueRouter2.default({
  routes: routes,
  mode: 'history',
  base: '/'
});

var toURL = null;
router.beforeEach(function (to, from, next) {
  var token = _store2.default.localStorage.getItem(_store2.default.keys.token);
  var sysInfo = _store2.default.localStorage.getItem(_store2.default.keys.sysInfo);

  if (!sysInfo || !sysInfo.id) {
    sysInfo = { id: to.params.id };
  }

  // 如果需要登录权限
  if (to.meta.auth) {
    // 登录
    if (to.meta.auth.includes('authc') && !token) {
      return next({ name: 'login', params: { id: sysInfo.id }, query: { redirect: to.query.redirect } });
    }
  }

  // // TODO ios测试
  // if (isIOS()) {
  //   // 解决ios微信底部返回栏
  //   if (toURL === to.path) {
  //     return next();
  //   }
  //   if (to.path !== from.path) {
  //     toURL = to.path;
  //     router.replace(to.fullPath);
  //     return next();
  //   }
  // }
  var title = _store2.default.sessionStorage.getItem(_store2.default.keys.title);
  document.title = title || to.meta.title || sysInfo.title || '';
  next();
});

exports.default = router;


//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = 585
// module chunks = 14